/**
 * Service used to call and execute condition data rest endpoint
 */
import ApiService from './ApiService'

const resourceUrl = `${ApiService.prefix}rest/condition`

export default {
  getConditionDataJSON(data) {
    return ApiService.post(`${resourceUrl}/generate`, data)
  },
  getBulkConditionDataJSON(data) {
    return ApiService.post(`${resourceUrl}/generateBulk`, data)
  },
}
